'use client'
import {
  SCHEDULE_QUERY
} from "./chunk-HLVUCALY.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  minifyGqlQuery
} from "./chunk-UBYW5IHO.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/events/yearly.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var buildQuery = () => {
  const months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
  ];
  const year = (/* @__PURE__ */ new Date()).getFullYear();
  return gql`
    query getCalendarEvents($lang: String, $limit: Int, $skip: Int, $where: EventFilter, $order: [EventOrder]) {
      ${months.map((month) => {
    const monthIndex = months.indexOf(month);
    const start = new Date(year, monthIndex, 1, 0, 0, 0);
    const end = new Date(year, monthIndex + 1, 0, 23, 59, 59);
    return `
            ${month}: eventCollection(
              locale: $lang
              limit: $limit
              skip: $skip
              where: {
                AND: [
                  $where
                  { schedule: { openDateTime_gt: "${start.toISOString()}", openDateTime_lt: "${end.toISOString()}" } }
                ]
              }
              order: $order
            ) {
              total
              items {
                id
                title
                slug
                image11 {${IMAGE_QUERY}}
                schedule {${SCHEDULE_QUERY}}
              }
            }
          `;
  }).join("\n")}
    }
  `;
};
var getYearlyEvents = (props) => __async(void 0, null, function* () {
  try {
    const QUERY = buildQuery();
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), __spreadValues({
      order: ["tier_ASC", "order_ASC"],
      visibility_not: "private"
    }, props));
    return res;
  } catch (error) {
    throw new Exception({ error, name: "getYearlyEventsException" });
  }
});
var useGetYearlyEvents = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getYearlyEvents", props],
    queryFn: () => getYearlyEvents(props)
  }));
};

export {
  getYearlyEvents,
  useGetYearlyEvents
};
//# sourceMappingURL=chunk-RHC47SEZ.mjs.map